import React, { useState, useEffect } from "react";
import {
  Layout,
  Space,
  Card,
  Table,
  Select,
  Modal,
  Button,
  Form,
  Input,
  Row,
  Col,
  InputNumber,
  Avatar,
} from "antd";
import {
  AppstoreAddOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import CopyRight from "./CopyRight";
import SideBar from "./_sideBar";

const { Content } = Layout;
const { Option } = Select;
const MerchantBank = () => {
  const navigate = useNavigate();
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [nextMenuDisabled, setNextMenuDisabled] = useState(false);
  const [merchantList, setMerchantList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [form] = Form.useForm();
  const { id } = useParams();

  const loginUser = JSON.parse(localStorage.getItem("loginUser"));
  const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));

  const bankList = [
    { id: "kbz", name: "KBZ" },
    { id: "cb", name: "CB" },
    { id: "aya", name: "AYA" },
    { id: "okdollar", name: "OK$" },
  ];

  const bankColumns = [
    { title: "Bank Name", dataIndex: "bankName", key: "bankName" },
    {
      title: "Merchant Code",
      dataIndex: "bankMerchantCode",
      key: "bankMerchantCode",
    },
    { title: "Auth Token", dataIndex: "authToken", key: "authToken" },
    { title: "App ID", dataIndex: "appId", key: "appId" },
    { title: "Endpoint URL", dataIndex: "endpointUrl", key: "endpointUrl" },
  ];

  // Handle bank selection change
  const handleSelectChange = (value) => {
    if (selectedBank === value) {
      setModalVisible(false);
      setTimeout(() => {
        setSelectedBank(value);
        form.setFieldsValue({ systemMerchantID: id });
        setModalVisible(true);
      }, 100);
    } else {
      setSelectedBank(value);
      form.setFieldsValue({ systemMerchantID: id });
      setModalVisible(true);
    }
  };

  // Fetch merchant data based on bank selection
  const fetchMerchantData = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/findBanks/${id}`,
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
        }
      )
      .then((response) => {
        setMerchantList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching merchant data:", error);
      });
  };

  // Form submission for saving merchant data
  const handleSave = (values) => {
    const data = { ...values, systemMerchantID: id };
    axios
      .post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/merchant/${selectedBank}merchant`,
        data,
        {
          headers: {
            Authorization: `Bearer ${loginUserToken}`,
          },
        }
      )
      .then((response) => {
        setModalVisible(false);
        form.resetFields();
        fetchMerchantData(); // Fetch updated merchant data
      })
      .catch((error) => {
        console.error("Error saving merchant data:", error);
      });
  };

  useEffect(() => {
    fetchMerchantData();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (selectedBank) {
      setModalVisible(true);
    }
  }, [selectedBank]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SideBar
        menuDisabled={menuDisabled}
        nextMenuDisabled={nextMenuDisabled}
        fontSize="14px"
        drawerVisibleValue={drawerVisible}
        setDrawerVisibleValue={setDrawerVisible}
      />

      <Layout className="site-layout">
        <Content>
          <div className="site-layout-background" style={{ minHeight: 360 }}>
            <Space
              direction="vertical"
              style={{ padding: "10px", width: "100%" }}
            >
              <Card
                title={
                  <span>
                    {isMobile && (
                      <MenuOutlined
                        onClick={() => setDrawerVisible((prev) => !prev)}
                        style={{ marginRight: 8, fontSize: 30 }}
                      />
                    )}
                    <AppstoreAddOutlined style={{ marginRight: 8 }} />
                    MERCHANT BANKS
                  </span>
                }
                headStyle={{ backgroundColor: "#cccccc" }}
                extra={
                  <span>
                    {loginUser?.username}
                    <Avatar
                      src={loginUser?.avatarUrl}
                      icon={!loginUser?.avatarUrl && <UserOutlined />}
                      style={{ marginLeft: 8 }}
                    />
                  </span>
                }
              >
                <Select
                  style={{
                    width: "100%",
                    maxWidth: 200,
                    marginBottom: 16,
                  }}
                  onSelect={handleSelectChange}
                  defaultValue={"Add Merchant Bank"}
                >
                  {bankList.map((bank) => (
                    <Option key={bank.id} value={bank.id}>
                      {bank.name}
                    </Option>
                  ))}
                </Select>
                <Table
                  dataSource={merchantList}
                  columns={bankColumns}
                  rowKey="id"
                  pagination={{ pageSize: 5 }}
                  bordered
                  scroll={{ x: "max-content" }}
                  style={{ width: "100%" }}
                />
              </Card>
            </Space>
          </div>
          <CopyRight />
        </Content>
      </Layout>

      <Modal
        title={`Add ${selectedBank?.toUpperCase()} Merchant`}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width="100%" // Set a wider width for the modal
        style={{ maxWidth: "900px", width: "100%" }} // Ensure it doesn't exceed a certain width
        // bodyStyle={{ padding: "20px" }}
      >
        <Form form={form} onFinish={handleSave} layout="vertical">
          {selectedBank === "kbz" && (
            <>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Merchant Code"
                    name="merchantCode"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="App ID"
                    name="appId"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Auth Token"
                    name="authToken"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Notify URL"
                    name="notifyUrl"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Sign Type"
                    name="signType"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Secret Key"
                    name="secretKey"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Method"
                    name="method"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Version"
                    name="version"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Trade Type"
                    name="tradeType"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Title"
                    name="title"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Callback Info"
                    name="callbackInfo"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="TimeOut Express"
                    name="timeOutexpress"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Payment Method"
                    name="paymentMethod"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="KBZ Url"
                    name="kbzUrl"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Query Order Url"
                    name="queryOrderUrl"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Service Fees"
                    name="serviceFees"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a valid number",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      min={0}
                      step={0.01} // Allow decimal values
                      parser={(value) => value?.replace(/\$\s?|,/g, "")} // Optional: remove currency symbols or commas if added
                      formatter={(value) =>
                        value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      } // Optional: add comma separators
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          {selectedBank === "cb" && (
            <>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Merchant Code"
                    name="merchantCode"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Sub Merchant Code"
                    name="subMerchantCode"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Terminal ID"
                    name="terminalId"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Auth Token"
                    name="authToken"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="CB URL"
                    name="cbUrl"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Endpoint URL"
                    name="endpointUrl"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item label="Payment Method" name="paymentMethod">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label="Service Fees"
                    name="serviceFees"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a valid number",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      min={0}
                      step={0.01} // Allow decimal values
                      parser={(value) => value?.replace(/\$\s?|,/g, "")} // Optional: remove currency symbols or commas if added
                      formatter={(value) =>
                        value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      } // Optional: add comma separators
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
};

export default MerchantBank;
